/** @format */

import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import {
  replaceUnderscoresWithSpaces,
} from "utils/strings";
import loginbg from "images/Login.png";
import { ReactComponent as EnvIcon } from "images/svg/enveloope.svg";
import AuthHeader from "./components/auth-header";
import { useResendOTPMutation } from "store/services/authAPI";
import { ReactComponent as CheckEmailIcon } from "images/svg/check-email.svg";
import plane1 from "images/new/email-plane-1.svg";
import plane2 from "images/new/email-plane-2.svg";
import plane3 from "images/new/email-plane-3.svg";
import bell from "images/new/email-bell.svg";
import emailCount from "images/new/email-count.svg";
import waveblue from "images/new/email-wave-blue.svg";
import wavered from "images/new/email-wave-red.svg";
import wavegreen from "images/new/email-wave-green.svg";
import emailTriangle from "images/new/email-triangle.svg";
import emailMultiply from "images/new/email-multiply.svg";
import emailCircle from "images/new/email-circle.svg";
import emailPlusBlue from "images/new/email-plus-blue.svg";
import emailPlusYellow from "images/new/email-plus-yellow.svg";
import emailPlusDeepBlue from  "images/new/email-plus-deep-blue.svg";


function CompleteRegistration() {
  const [resendOTP, { isLoading: requesting }] = useResendOTPMutation();
  const [showCheckEmail, setShowCheckEmail] = React.useState(false);

  const handleSubmit = async (values) => {
    await resendOTP({
      email: values.email,
    })
      .unwrap()
      .then((data) => {
        setShowCheckEmail(true);
      })
      .catch((error) => {
        const errorText = error?.data?.detail;
        const btnText = "Try Again";

        Swal.fire({
          title: error?.data?.code
            ? replaceUnderscoresWithSpaces(error?.data?.code)
            : "Error Occured",
          iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
          text: errorText || "Error Occured",
          showCloseButton: true,
          customClass: {
            icon: "no-border",
          },
          cancelButtonText: btnText,
          showConfirmButton: false,
          showCancelButton: true,
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: UserSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <div
        className="login-main-page auth-page"
        style={{
          background: "url(" + loginbg + ")",
          backgroundSize: "contain",
        }}
      >
        <AuthHeader />

        <div className="login-wrapper w-100 mt-4">
          <div className="container h-100">
            <div className="row h-100 align-items-center justify-content-center">
              <div className="col-xl-6 mt-3">
                {showCheckEmail ? (
                  <div className="card auth-card">
                    <div className="card-body p-0">
                      <div className="row m-0">
                        <div className="col-xl-12 col-md-12">
                          <div className="sign-in-your text-center">
                            <figure className="bg-tip email-one">
                              <img src={plane1} alt="paperplane" />
                            </figure>
                            <figure className="bg-tip email-two">
                              <img src={plane2} alt="paperplane" />
                            </figure>
                            <figure className="bg-tip email-three">
                              <img src={plane3} alt="paperplane" />
                            </figure>
                            <figure className="bg-tip email-bell">
                              <img src={bell} alt="bell" />
                            </figure>
                            <figure className="bg-tip email-count">
                              <img src={emailCount} alt="bell" />
                            </figure>
                            <figure className="bg-tip email-wave-red">
                              <img src={wavered} className="width-50px" alt="bell" />
                            </figure>
                            <figure className="bg-tip email-wave-blue">
                              <img src={waveblue} className="width-50px" alt="bell" />
                            </figure>
                            <figure className="bg-tip email-wave-green">
                              <img src={wavegreen} className="width-50px" alt="bell" />
                            </figure>
                            <figure className="bg-tip email-multiply">
                              <img src={emailMultiply} alt="multiply" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-triangle">
                              <img src={emailTriangle} alt="triangle" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-circle">
                              <img src={emailCircle } alt="circle" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-plus-blue">
                              <img src={emailPlusBlue} alt="plus-blue" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-plus-yellow">
                              <img src={emailPlusYellow} alt="plus-yellow" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-triangle-bottom ">
                              <img src={emailTriangle} alt="triangle" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-multiply-bottom ">
                              <img src={emailMultiply} alt="multiply" className="width-8px"/>
                            </figure>
                            <figure className="bg-tip email-plus-deep-blue">
                              <img src={emailPlusDeepBlue} alt="plus" className="width-8px"/>
                            </figure>
                            <CheckEmailIcon className="mb-3"/>
                            <div className="">
                              <h4 className="registration-heading mb-3">
                                Check your mailbox
                              </h4>
                              <p className="registration-title ">
                                We’ve sent you an email buddy, please <br />
                                check your mailbox for an email from 3MTT
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card auth-card">
                    <div className="card-body p-0">
                      <div className="row m-0">
                        <div className="col-xl-12 col-md-12">
                          <div className="sign-in-your">
                            <h4 className="fs-20 font-w800 text-black">
                              Complete Registration
                            </h4>

                            <p className="mb-2 welcome">
                              Don’t miss out, verify and get started!                            
                            </p>

                            <form
                              className="form mt-4"
                              onSubmit={formik.handleSubmit}
                            >
                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Email Address</strong>
                                </label>

                                <div className="password__container">
                                  <EnvIcon />
                                  <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    placeholder="e.g. example@domainname.com"
                                    {...formik.getFieldProps("email")}
                                  />
                                </div>

                                {formik.touched.email && formik.errors.email ? (
                                  <div className="text-danger mt-2 fs-12">
                                    {formik.errors.email}
                                  </div>
                                ) : null}
                              </div>

                              <div className="text-center">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-block"
                                >
                                  {requesting ? (
                                    <span
                                      role="status"
                                      aria-hidden="true"
                                      className="spinner-border spinner-border-sm ms-2"
                                    ></span>
                                  ) : (
                                    "Request Link"
                                  )}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompleteRegistration;

const UserSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});
